import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AustinsMobileSpaOnWheels from "./sections/AustinsMobileSpaOnWheels";
import OurCoreCompetencies from "./sections/OurCoreCompetencies";
import OurDesignProcess from "./sections/OurDesignProcess";
import WhyChooseSmithServices from "./sections/WhyChooseSmithServices";
import VoicesOfSecurity from "./sections/VoicesOfSecurity";
import TheIgnition from "./sections/TheIgnition";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AustinsMobileSpaOnWheels />
      <OurCoreCompetencies />
      <OurDesignProcess />
      <WhyChooseSmithServices />
      <VoicesOfSecurity />
      <TheIgnition />
      <Footer />
    </div>;
}